import * as Yup from "yup";

export const DEVICE_TYPE = {
  GPS: "GPS",
  Wifi: "Wifi",
  // Beacon: "Beacon",
  // Fingerprint: "Fingerprint",
};

export const initialValues = {
  deviceType: null,
  deviceTypeId: null,
  workInLocationName: null,
  departmentListId: [],
  locationCoordinates: null,
  radius: 0,
  deviceName: null,
  serialNumber: null,
  deviceId: null,
  enableTimeLock: true,
  automaticAddEmployee: true,
};

const WorkingLocationSchema = Yup.object().shape({
  deviceTypeId: Yup.string().required("Please select."),
  workInLocationName: Yup.string().required("Please enter."),
  departmentListId: Yup.array()
    .of(Yup.string().required("Please select."))
    .min(1, "Please select"),
  locationCoordinates: Yup.string().when("deviceType", {
    is: (val) => val === DEVICE_TYPE.GPS,
    then: () => Yup.string().required("Please enter."),
    otherwise: () => Yup.string().notRequired(),
  }),
  deviceName: Yup.string().when("deviceType", {
    is: (val) => val !== DEVICE_TYPE.GPS,
    then: () => Yup.string().required("Please enter device name."),
    otherwise: () => Yup.string().notRequired(),
  }),
  serialNumber: Yup.string().when("deviceType", {
    is: (val) => val === DEVICE_TYPE.Beacon || val === DEVICE_TYPE.Fingerprint,
    then: () => Yup.string().required("Please enter serial number."),
    otherwise: () => Yup.string().notRequired(),
  }),
  deviceId: Yup.string().when("deviceType", {
    is: (val) => val === DEVICE_TYPE.Wifi,
    then: () => Yup.string().required("Please enter device id."),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export default WorkingLocationSchema;
